import React from "react";
import cn from "classnames";
import { ReactComponent as TelegramIcon } from "./icons/telegramIcon.svg";
import { ReactComponent as LinkedinIcon } from "./icons/linkedinIcon.svg";
import { ReactComponent as GithubIcon } from "./icons/githubIcon.svg";
import { ReactComponent as SkypeIcon } from "./icons/skypeIcon.svg";

import styles from "./Socials.module.css";

export default function Socials() {
    const socialIcons = [
        {
            href: "https://t.me/Alec_Oaker",
            icon: (
                <TelegramIcon
                    className={cn(styles.telegramIcon, styles.icons)}
                />
            ),
            ariaLabel: "Telegram",
        },
        {
            href: "https://www.linkedin.com/in/oleg-dub/",
            icon: (
                <LinkedinIcon
                    className={cn(styles.linkedinIcon, styles.icons)}
                />
            ),
            ariaLabel: "Linkedin",
        },
        {
            href: "https://github.com/IamOlegDub",
            icon: (
                <GithubIcon className={cn(styles.githubIcon, styles.icons)} />
            ),
            ariaLabel: "GitHub",
        },
        {
            href: "https://join.skype.com/invite/HfBooW8phrdr",
            icon: <SkypeIcon className={cn(styles.skypeIcon, styles.icons)} />,
            ariaLabel: "Skype",
        },
    ];
    return socialIcons.map((el) => (
        <a
            href={el.href}
            key={el.href}
            target="_blank"
            rel="noreferrer"
            className={cn(styles.iconsLink)}
            aria-label={el.ariaLabel}
        >
            {el.icon}
        </a>
    ));
}
